import { Link } from 'react-router-dom';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { IconButtonWrapper } from '~/components/common';

export const Container = styled.li`
  display: block;
  position: relative;
  background: ${({ theme }) => theme.content.content_dark_1};
  ${({ theme }) => theme.mixins.aspectRatio.ratio5_6};
`;

export const ImageBox = styled.div`
  ${({ theme }) => css`
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
    border: 1px solid ${theme.stroke.stroke_2};
    border-radius: 4px;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  `}
`;

export const NameBox = styled.div`
  display: block;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 8px;
`;

export const Name = styled.span`
  ${({ theme }) => css`
    display: block;
    width: 100%;
    ${theme.fontStyle.text.body14_bold}
    font-size: ${theme.content.content_light_1};
    text-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
    ${theme.mixins.text.ellipsis_1};
  `}
`;

export const EditLink = styled(Link)`
  position: absolute;
  top: 0;
  right: 0;
  width: 36px;
  height: 36px;
  padding: 8px;
  cursor: pointer;
`;

export const ButtonBox = styled(IconButtonWrapper)`
  ${({ theme }) => css`
    position: absolute;
    top: 0;
    right: 0;
    padding: 8px;
    color: ${theme.content.content_light_1};
    cursor: pointer;
  `}
`;

export const IconBackWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background: ${theme.backgroundColor.bg_dark_5_alpha};
    gap: 8px;
    backdrop-filter: blur(5px);
  `}
`;
